import { render, staticRenderFns } from "./k-field-cascader.vue?vue&type=template&id=12f88938"
import script from "./k-field-cascader.vue?vue&type=script&lang=js"
export * from "./k-field-cascader.vue?vue&type=script&lang=js"
import style0 from "./k-field-cascader.vue?vue&type=style&index=0&id=12f88938&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports